import { render } from "./FooterCopyright.vue?vue&type=template&id=6425a38b"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import exportComponent from "E:\\myproject\\vuejs-tailwindcss-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__